import React, { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideNotification, selectNotification, showNotification } from 'store/reducers/notification';
import { Slide, Snackbar } from '@mui/material';
import { addNotification } from 'store/reducers/notifications';

const vertical = 'top';
const horizontal = 'right';

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

const Notification = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const { message } = useSelector(selectNotification);

  const [open, setOpen] = React.useState(false);

  // useEffect(() => {
  //   // Handle incoming messages and dispatch them to Redux
  //   window.socket.onmessage = (event) => {
  //     const message = JSON.parse(event.data);
  //     dispatch(addNotification(message));
  //   };
  // }, []);

  useEffect(() => {
    // Handle incoming messages and dispatch them to Redux
    if (window.socket) {
      window.socket.onmessage = (event) => {
        const message = event.data;
        dispatch(addNotification(message));
        dispatch(showNotification(message.message));
      };
    }

    if (message) {
      setOpen(true);

      const timer = setTimeout(() => {
        setOpen(false);
        dispatch(hideNotification());
      }, 2000); // Auto hide after 2 seconds
      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);

  const handleClose = () => {
    setOpen(false);
    dispatch(hideNotification());
  };

  return (
    <Snackbar
      ref={ref}
      open={open}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      message={message}
      autoHideDuration={2000}
      anchorOrigin={{ vertical, horizontal }}
    />
  );
});

export default Notification;
